<template>
    <div class="card">
        <div class="card-header">
            <h3 class="card-title">Sesión del día {{ sesion ? sesion.fecha  : ''}}</h3>
        </div>

        <div class="card-body" v-if="!loading">
            <div class="card card-primary card-outline card-outline-tabs">
                <div class="card-header p-0 border-bottom-0">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item">
                            <a :class="mode === 1 ? 'nav-link active' : 'nav-link'"
                                @click.prevent="mode = 1"
                                href="#"
                            >
                                Venta normal
                            </a>
                        </li>
                        <li v-if="evento && evento.descuento_abonado && evento.tiene_recinto" class="nav-item">
                            <a :class="mode === 2 ? 'nav-link active' : 'nav-link'"
                                @click.prevent="mode = 2"
                                href="#"
                            >
                                Venta día del abonado
                            </a>
                        </li>
                        <li v-if="evento && evento.amigo_abonado && evento.tiene_recinto" class="nav-item">
                            <a :class="mode === 3 ? 'nav-link active' : 'nav-link'"
                                @click.prevent="mode = 3"
                                href="#"
                            >
                                Venta amigo abonado
                            </a>
                        </li>
                        <li class="nav-item">
                            <a :class="mode === 4 ? 'nav-link active' : 'nav-link'"
                                @click.prevent="mode = 4"
                                href="#"
                            >
                                Reserva de butacas online
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <VentaNormalComponent
                v-if="mode === 1"
                :evento="evento"
                :mode="mode"
                :sesion="sesion"
                :recinto="recinto"
                :entradas="entradas"
                :paso="paso"
                @cambiarPaso="cambiarPaso"
                @resetearEntradas="resetearEntradas" 
            />

            <VentaAbonadoComponent 
                v-else-if="mode === 2"
                :evento="evento"
                :mode="mode"
                :sesion="sesion"
                :recinto="recinto"
                :entradas="entradas"
                :paso="paso"
                @cambiarPaso="cambiarPaso"
                @resetearEntradas="resetearEntradas" 
            />
                
            <VentaAmigoAbonadoComponent
                v-else-if="mode === 3"
                :evento="evento"
                :mode="mode"
                :sesion="sesion"
                :recinto="recinto"
                :entradas="entradas"
                :paso="paso"
                @cambiarPaso="cambiarPaso"
                @resetearEntradas="resetearEntradas" 
            />

            <ReservaButacasComponent
                v-else-if="mode === 4"
                :evento="evento"
                :sesion="sesion"
            />
        </div>

        <div class="card-body" v-else>
            <LoaderComponent></LoaderComponent>
        </div>
    </div>
</template>

<script>
import LoaderComponent from '@/components/preloader/LoaderComponent';
import VentaNormalComponent from '@/components/backend/stepper/eventos/tipo-de-venta/VentaNormalComponent.vue';
import VentaAbonadoComponent from '@/components/backend/stepper/eventos/tipo-de-venta/VentaAbonadoComponent.vue';
import VentaAmigoAbonadoComponent from '@/components/backend/stepper/eventos/tipo-de-venta/VentaAmigoAbonadoComponent.vue';
import ReservaButacasComponent from '../../stepper/eventos/tipo-de-venta/ReservaButacasComponent.vue';

export default {
    props: ['evento', 'sesion'],
    data() {
        return {
            mode: 1,
            loading: false,
            paso: 1,
            entradas: [],
        }
    },
    created() {
        this.asignarEntradas();
    },
    watch: {
        mode() {
            this.cambiarPaso(1);
        }
    },
    computed: {
        recinto() {
            if(!this.evento) {
                return null;
            }

            if(this.evento.tiene_recinto) {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        asignarEntradas() {
            this.entradas = this.sesion.entradas;
            for(var i in this.sesion.entradas) {
                this.entradas[i].unidades = 0;
            }                    
        },
        cambiarPaso(paso, reiniciar = false) {
            if (reiniciar) {
                localStorage.removeItem('zona_id');
                this.resetearEntradas(true);
            }
            this.paso = paso
        },
        resetearEntradas(reiniciar = false) {
            this.entradas = [];
            this.asignarEntradas();
            if(reiniciar) {
                this.$emit('getEvento');
            }
        }
    },
    components: {
        LoaderComponent, VentaNormalComponent, VentaAbonadoComponent, VentaAmigoAbonadoComponent, ReservaButacasComponent
    }
}
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
